var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_show)?_c('div',{staticClass:"newsletter-form"},[_c('Close',{nativeOn:{"click":function($event){_vm.is_show = false}}}),_c('div',{staticClass:"box"},[_c('iframe',{attrs:{"src":_vm.url}})])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }